import React, { createContext, useContext, useEffect, useState, useRef } from 'react';
import { io } from 'socket.io-client';
import toast from 'react-hot-toast';

const SocketContext = createContext(null);

export const SocketProvider = ({ children }) => {
  const [socket, setSocket] = useState(null);
  const [whatsappStatus, setWhatsappStatus] = useState(null);
  const [qrCode, setQrCode] = useState(null);
  const [connected, setConnected] = useState(false);
  const socketRef = useRef(null);

  useEffect(() => {
    const token = localStorage.getItem('accessToken');
    if (!token) return;

    const s = io(process.env.REACT_APP_SOCKET_URL || 'http://localhost:3000', {
      auth: { token },
      transports: ['websocket', 'polling'],
    });

    s.on('connect', () => {
      setConnected(true);
      s.emit('subscribe', ['whatsapp_status', 'message_status', 'whatsapp_qr']);
    });

    s.on('disconnect', () => setConnected(false));

    s.on('whatsapp_qr', (data) => {
      setQrCode(data.qr);
    });

    s.on('whatsapp_status', (data) => {
      setWhatsappStatus(data.status);
      if (data.status && data.status.connected) setQrCode(null);
    });

    s.on('message_status', (data) => {
      toast.success('Message ' + data.messageId + ': ' + data.status, { duration: 2000 });
    });

    s.on('whatsapp_error', (data) => {
      toast.error('WhatsApp Error: ' + data.error);
    });

    socketRef.current = s;
    setSocket(s);

    return () => {
      s.disconnect();
      socketRef.current = null;
    };
  }, []);

  return (
    <SocketContext.Provider value={{ socket, connected, whatsappStatus, qrCode, setQrCode }}>
      {children}
    </SocketContext.Provider>
  );
};

export const useSocket = () => useContext(SocketContext);
